"use client";

import { createClient } from "./client";

const projectId = process.env.NEXT_PUBLIC_SUPABASE_PROJECT_ID;

const endpoint =
  process.env.NODE_ENV === "production"
    ? `https://${projectId}.storage.supabase.co/storage/v1/upload/resumable`
    : "http://127.0.0.1:54321/storage/v1/upload/resumable";

export async function uploadFile(
  bucketName: string,
  storagePath: string,
  file: File,
  onProgress?: (percentage: number) => void,
) {
  // Dynamically import tus-js-client to avoid SSR issues (it uses browser-only APIs)
  const tus = await import("tus-js-client");

  const supabase = createClient();
  const {
    data: { session },
  } = await supabase.auth.getSession();
  return new Promise((resolve, reject) => {
    const upload = new tus.Upload(file, {
      // Supabase TUS endpoint (with direct storage hostname)
      endpoint: endpoint,
      retryDelays: [0, 3000, 5000, 10000, 20000],
      headers: {
        authorization: `Bearer ${session?.access_token}`,
        "x-upsert": "true", // optionally set upsert to true to overwrite existing files
      },
      uploadDataDuringCreation: true,
      removeFingerprintOnSuccess: true, // Important if you want to allow re-uploading the same file https://github.com/tus/tus-js-client/blob/main/docs/api.md#removefingerprintonsuccess
      metadata: {
        bucketName: bucketName,
        objectName: storagePath,
        contentType: file.type,
        cacheControl: "3600",
      },
      chunkSize: 6 * 1024 * 1024, // NOTE: it must be set to 6MB (for now) do not change it
      onError: (error) => {
        console.log(`Failed because: ${error}`);
        reject(error);
      },
      onProgress: (bytesUploaded, bytesTotal) => {
        const percentage = (bytesUploaded / bytesTotal) * 100;
        onProgress?.(percentage);
      },
      onSuccess: () => {
        console.log("Download %s from %s", upload.file, upload.url);
        resolve(upload.url);
      },
    });
    // Check if there are any previous uploads to continue.
    return upload.findPreviousUploads().then((previousUploads) => {
      // Found previous uploads so we select the first one.
      if (previousUploads.length) {
        upload.resumeFromPreviousUpload(previousUploads[0]);
      }
      // Start the upload
      upload.start();
    });
  });
}
